import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { ReportDialogs } from '../../constants/Dialogs';

import ReportActions from '../../actions/ReportActionCreator';
import ReportShareStore from '../../stores/ReportShareStore';
import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';


class ReportShareDialog extends Component {

    componentDidMount() {
        if (!!this.props.reportId) {
            ReportActions.getShare(this.props.reportId, true);
        }
    }

    render() {
        return (
            <Dialog
                title="Share report"
                open={this.state.open}
                modal={false}
                onRequestClose={this.props.onClose}
                actions = {[<FlatButton key="close" label="OK" onTouchTap={this.props.onClose} />]}
            >
                Share this report with others by generating a unique URL <br /> <br />
                <TextField
                    name="url"
                    value={!this.state.shareKey ? '' : `${window.location.origin}/shared/reporting/${this.state.shareKey}`}
                    rowsMax={2}
                    hintText="URL"
                    multiLine
                    fullWidth
                    textareaStyle={{fontSize: 14}}
                />
                <RaisedButton
                    label={!this.state.shareKey ? 'Generate' : 'Remove'}
                    onTouchTap={
                        !this.state.shareKey
                            ? () => this.props.shareAction(this.props.reportId)
                            : () => this.props.deleteShareAction(this.state.shareKey)
                    }
                    secondary={!this.state.shareKey}
                />
            </Dialog>
        );
    }

}

ReportShareDialog.getStores = () => [ReportShareStore, DialogStore];
ReportShareDialog.calculateState = (prevState, {reportId}) => ({
    open: !!reportId && DialogStore.getOpenDialog() === ReportDialogs.REPORT_SHARE,
    shareKey: ReportShareStore.getKeyByReportId(reportId) || null
});

ReportShareDialog.propTypes = {
    reportId:           PropTypes.number.isRequired,
    shareAction:        PropTypes.func,
    deleteShareAction:  PropTypes.func,
    onClose:            PropTypes.func
};

ReportShareDialog.defaultProps = {
    shareAction:        ReportActions.addShare,
    deleteShareAction:  ReportActions.deleteShare,
    onClose:            DialogActions.close
};

export default Container.create(ReportShareDialog, {withProps: true});
